import { Link } from 'react-router-dom';
import { business } from '../content';
import { useLanguage } from '../language/LanguageContext';
import { fillTemplate } from '../language/translations';

function Home() {
  const { t } = useLanguage();
  const home = t.home;
  const values = {
    appName: business.appName,
    companyName: business.companyName
  };

  return (
    <>
      <section className="hero-section">
        <div className="hero-content">
          <p className="eyebrow">{home.eyebrow}</p>
          <h1>{fillTemplate(home.title, values)}</h1>
          <p className="hero-copy">{fillTemplate(home.copy, values)}</p>
          <div className="hero-actions">
            <Link className="button primary" to="/support">
              {home.supportCta}
            </Link>
            <Link className="button secondary" to="/privacy-security">
              {home.privacyCta}
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <p className="eyebrow">{home.featuresEyebrow}</p>
          <h2>{home.featuresTitle}</h2>
        </div>
        <div className="feature-grid">
          {home.features.map((feature) => (
            <article className="feature-card" key={feature}>
              <span className="feature-icon">✓</span>
              <p>{feature}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section split-section">
        <div>
          <p className="eyebrow">{home.reviewEyebrow}</p>
          <h2>{home.reviewTitle}</h2>
        </div>
        <div className="link-list">
          <Link to="/privacy-security">{t.nav.privacy}</Link>
          <Link to="/terms-conditions">{t.terms.title}</Link>
          <Link to="/support">{t.nav.support}</Link>
          <Link to="/delete-account">{t.nav.deleteAccount}</Link>
        </div>
      </section>
    </>
  );
}

export default Home;
